import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import Store from './store'
import JoinGroupModal from './JoinGroupModal'
import { Provider } from 'mobx-react'
import style from './style.module.less'

export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }

  getImages = () => {
    return [
      '//qnm.hunliji.com/o_1dn9kubgo13991oi51o7t15abl4gd.png',
      '//qnm.hunliji.com/o_1dn9kubgott71nhm14clk60ffqe.png',
      '//qnm.hunliji.com/o_1dn9kubgp1kki8d1faion41btuf.png',
      '//qnm.hunliji.com/o_1dn9kubgp137kvalrnkjvahhg.png',
      '//qnm.hunliji.com/o_1dn9kubgp1u7t1vkt45t1gdmhehh.png'
    ]
  }

  render() {
    return (
      <Provider store={this.store}>
        <HeaderView contentStyle={{ padding: '0 0 20px' }}>
          <div className={style.wrapper}>
            {this.getImages().map((item, index) => {
              return <img key={index} src={item} />
            })}
          </div>

          <JoinGroupModal />
        </HeaderView>
      </Provider>
    )
  }
}
